import { useTranslation } from 'react-i18next'
import { LayerGroup, LayersControl } from 'react-leaflet'
import { KommuneplanLayer } from '../KommuneplanLayer'

export const KommuneplanLayers: React.FC = () => {
  const { t } = useTranslation(['map', 'common'])
  return (
    <>
      <LayersControl.Overlay name={`<b><u>${t('municipal-plans', { defaultValue: 'Kommuneplaner' })}</u></b>`}>
        <LayerGroup></LayerGroup>
      </LayersControl.Overlay>
      <LayersControl.Overlay name={t('area-purpose', { defaultValue: 'Arealformål' })}>
        <KommuneplanLayer />
      </LayersControl.Overlay>
    </>
  )
}
